import angular from 'angular';
import SideBannersComponent from './side-banners.component';

let SideBannersModule = angular.module('shared.components.banners.sideBannersModules.sideBanners', [])
  .component('sideBanners', SideBannersComponent);

export default SideBannersModule;



// WEBPACK FOOTER //
// ./www/components/shared/components/banners/side-banners/side-banners.js